


























  import {
    Vue,
    Component
} from "@/shared/vuepack";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { Address } from "@/shared/types";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useThemeStore } from "@/shared/store/theme";
import * as datadog from "@/shared/datadog";

@Component({
    components: {
    }
  })
  export default class DeactivateCardCompleteForm extends Vue {
    debitCardManagementStore = useDebitCardManagementStore();
    contactInfoStore = useContactInfoStore();
    themeStore = useThemeStore();

    mounted (): void {
      this.contactInfoStore.getContactInformation();
    }

    get mailingAddress (): Address {
      if (!this.contactInfoStore.contactInformation
        || !this.contactInfoStore.contactInformation.mailingAddress) {

        const data = {
          cardNumberLast4: this.debitCardManagementStore.focusedDebitCard.cardNumberLast4,
          userDate: Date.now()
        };

        datadog.log(`MailingAddress not found`, data, "error");
        return null;
      }
      return this.contactInfoStore.contactInformation.mailingAddress;
    }

    get cardName () {
      return `${this.debitCardManagementStore.focusedDebitCard.firstName} ${this.debitCardManagementStore.focusedDebitCard.lastName}`;
    }
}
